module.exports = __webpack_public_path__ + "static/media/c.5ae9e64b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/c.mp3
// module id = 92
// module chunks = 0